{
	"name": "generic-front-end",
	"version": "2026.27.12",
	"license": "MIT",
	"engines": {
		"npm": "^11.0.0",
		"node": "^24.0.0"
	},
	"scripts": {
		"build:local": "ng build --configuration='local'",
		"build:integration": "ng build --configuration='integration'",
		"build:preprod": "ng build --configuration='preprod'",
		"build:production": "ng build --configuration='production'",
		"bundle-report": "ng build --stats-json && webpack-bundle-analyzer dist/stats.json",
		"datadog:upload": "datadog-ci sourcemaps upload ./dist/browser --service generic-front-end --release-version $npm_package_version --minified-path-prefix /app",
		"lint": "ng lint --fix",
		"ng": "ng",
		"start:nolr": "ng serve --live-reload=false",
		"start": "ng serve --port=4200 --host=everysens.localhost --configuration local",
		"start:proxy": "ng serve --proxy-config proxy.conf.json",
		"test": "jest --passWithNoTests --coverage=false --runInBand --ci",
		"test:coverage": "jest --passWithNoTests --coverage=true --runInBand --ci",
		"test:update-snapshot": "jest --updateSnapshot",
		"commit": "git-cz",
		"mark-unused-i18n": "i18n-unused mark-unused",
		"display-unused-i18n": "i18n-unused display-unused",
		"branchname": "BRANCH_NAME=$(git branch --show-current)",
		"branchname:win": "FOR /F %i IN ('git branch --show-current') DO set BRANCH_NAME=\"%i\"",
		"sonar": "npm run test && npm run branchname && sonar-scanner -Dsonar.host.url=https://sonarcloud.io -Dsonar.token=$SONAR_TOKEN -Dsonar.projectVersion=$npm_package_version -Dsonar.branch.name=$BRANCH_NAME",
		"sonar:win": "npm run test && npm run branchname:win && sonar-scanner -Dsonar.host.url=https://sonarcloud.io -Dsonar.token=$SONAR_TOKEN -Dsonar.projectVersion=$npm_package_version -Dsonar.branch.name=%BRANCH_NAME%"
	},
	"config": {
		"commitizen": {
			"path": "./node_modules/cz-conventional-changelog"
		}
	},
	"private": true,
	"dependencies": {
		"@amcharts/amcharts4": "4.10.40",
		"@angular-slider/ngx-slider": "^20.0.0",
		"@angular/animations": "^20.3.15",
		"@angular/cdk": "^20.2.14",
		"@angular/common": "^20.3.15",
		"@angular/compiler": "^20.3.15",
		"@angular/core": "^20.3.15",
		"@angular/forms": "^20.3.15",
		"@angular/material": "^20.2.14",
		"@angular/material-luxon-adapter": "^20.2.14",
		"@angular/platform-browser": "^20.3.15",
		"@angular/platform-browser-dynamic": "^20.3.15",
		"@angular/platform-server": "^20.3.15",
		"@angular/router": "^20.3.15",
		"@auth0/auth0-angular": "2.5.0",
		"@bluehalo/ngx-leaflet": "^20.0.0",
		"@bluehalo/ngx-leaflet-markercluster": "^20.0.0",
		"@datadog/browser-logs": "7.3.0",
		"@datadog/browser-rum": "7.3.0",
		"@datadog/browser-rum-angular": "7.3.0",
		"@everysens/fast-json-patch": "latest",
		"@everysens/frontend-shared-v2": "20.10.0",
		"@fortawesome/fontawesome-free": "7.1.0",
		"@fullcalendar/angular": "^6.1.20",
		"@fullcalendar/bootstrap5": "6.1.20",
		"@fullcalendar/core": "^6.1.20",
		"@fullcalendar/daygrid": "^6.1.20",
		"@fullcalendar/interaction": "^6.1.20",
		"@fullcalendar/list": "^6.1.20",
		"@fullcalendar/resource": "^6.1.20",
		"@fullcalendar/resource-timeline": "^6.1.20",
		"@fullcalendar/timegrid": "^6.1.20",
		"@hotjar/browser": "1.0.9",
		"@ngx-translate/core": "17.0.0",
		"@ngx-translate/http-loader": "17.0.0",
		"@primeuix/themes": "2.0.3",
		"@tailwindcss/postcss": "4.1.18",
		"@turf/area": "6.0.1",
		"@turf/boolean-contains": "6.0.1",
		"@turf/boolean-within": "6.0.1",
		"@turf/buffer": "5.1.5",
		"@turf/dissolve": "5.1.5",
		"@turf/distance": "6.0.1",
		"@turf/helpers": "6.1.4",
		"@turf/intersect": "6.1.3",
		"@turf/nearest-point-to-line": "6.0.0",
		"@turf/point-to-line-distance": "6.0.0",
		"@turf/random": "6.0.2",
		"@turf/turf": "^7.2.0",
		"@turf/voronoi": "5.1.5",
		"@types/jwt-decode": "2.2.1",
		"@types/leaflet.heat": "0.2.0",
		"@types/uuid": "8.0.1",
		"@zxing/browser": "0.1.5",
		"@zxing/library": "0.21.3",
		"@zxing/ngx-scanner": "^20.0.0",
		"ag-grid-angular": "^31.0.1",
		"ag-grid-community": "^31.0.1",
		"angular-imask": "7.6.1",
		"angular2-text-mask": "^9.0.0",
		"chart.js": "4.5.1",
		"clipboard.js": "1.0.1",
		"date-fns": "2.30.0",
		"file-saver": "2.0.5",
		"fs-extra": "8.1.0",
		"json2csv": "6.0.0-alpha.2",
		"jwt-decode": "2.2.0",
		"leaflet": "1.9.4",
		"leaflet-draw": "1.0.4",
		"leaflet-easybutton": "2.4.0",
		"leaflet-rotatedmarker": "0.2.0",
		"leaflet.heat": "0.2.0",
		"leaflet.markercluster": "1.5.3",
		"lodash-es": "4.17.21",
		"luxon": "3.4.3",
		"maplibre-gl": "5.6.2",
		"moment-timezone": "0.5.33",
		"ng2-charts": "5.0.4",
		"ngeohash": "0.6.3",
		"ngx-clipboard": "16.0.0",
		"ngx-colors": "^3.6.0",
		"ngx-device-detector": "^10.0.0",
		"ngx-gravatar": "13.0.0",
		"ngx-infinite-scroll": "^20.0.0",
		"ngx-mask": "^20.0.0",
		"ngx-material-timepicker": "^13.1.1",
		"ngx-progressbar": "14.0.0",
		"ol": "6.14.1",
		"postcss": "8.5.6",
		"quill": "1.3.7",
		"rxjs": "~7.8.1",
		"rxjs-compat": "6.6.7",
		"saturn-datepicker-ext": "8.0.6",
		"socket.io-client": "4.6.1",
		"tailwindcss": "4.1.18",
		"text-mask-addons": "^3.8.0",
		"tinycolor2": "1.6.0",
		"tslib": "^2.8.1",
		"tsutils": "3.21.0",
		"uuid": "13.0.0",
		"xmldom": "0.6.0",
		"zone.js": "^0.15.1"
	},
	"devDependencies": {
		"@angular-devkit/core": "^20.3.13",
		"@angular-devkit/schematics": "^20.3.13",
		"@angular/build": "20.3.15",
		"@angular/cli": "^20.3.13",
		"@angular/compiler-cli": "^20.3.15",
		"@angular/language-service": "^20.3.15",
		"@datadog/datadog-ci": "5.19.0",
		"@eslint/js": "9.39.2",
		"@types/chance": "1.1.7",
		"@types/chart.js": "4.0.1",
		"@types/file-saver": "2.0.7",
		"@types/googlemaps": "3.43.3",
		"@types/jest": "30.0.0",
		"@types/leaflet": "1.9.21",
		"@types/leaflet-draw": "1.0.13",
		"@types/leaflet-rotatedmarker": "0.2.6",
		"@types/leaflet.markercluster": "1.5.6",
		"@types/lodash-es": "4.17.12",
		"@types/luxon": "3.7.1",
		"@types/ngeohash": "0.6.8",
		"big-list-of-naughty-strings": "1.0.0",
		"chance": "1.1.13",
		"codelyzer": "^6.0.2",
		"dotenv": "8.1.0",
		"eslint": "9.39.2",
		"factory.ts": "1.4.1",
		"i18n-unused": "0.8.0",
		"jest": "30.2.0",
		"jest-environment-jsdom": "30.2.0",
		"jest-preset-angular": "16.0.0",
		"jsdom": "28.0.0",
		"lint-staged": "15.2.7",
		"object-hash": "1.3.1",
		"postcss": "^8.5.3",
		"prettier": "3.8.1",
		"prettier-plugin-tailwindcss": "0.7.2",
		"primeicons": "6.0.1",
		"primeng": "20.4.0",
		"sonarqube-scanner": "3.3.0",
		"source-map-explorer": "2.5.3",
		"ts-node": "10.9.2",
		"typescript": "5.8.3",
		"typescript-eslint": "8.54.0"
	},
	"jestSonar": {
		"reportPath": "reports",
		"reportFile": "sonarqube_report.xml",
		"indent": 4
	}
}
